import style from '../block.module.scss';

export const SubMenu = ({ item, theme }) => {
    return (
        <div className={style.subMenuContainer}>
            <div className={style.subMenuContent}>
                {theme !== 'groupe' && <p className={style.title}>{item.title}</p>}
                <ul className={style.subMenu}>
                    {item.children.map((subItem, index) => (
                        <li key={'subMenu-' + index}>
                            <a className={style.item} href={subItem.url}>
                                {subItem.icon && (
                                    <div className={style.icon}>
                                        <img src={subItem.icon} alt={''} width={26} height={24} />
                                    </div>
                                )}
                                <div className={style.text}>
                                    <p className={style.subtitle}>{subItem.title}</p>
                                    <p className={style.description}>{subItem.description}</p>
                                </div>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
